document.addEventListener('DOMContentLoaded', function() {
  if (typeof cart === 'undefined') {
    console.error('standard-range-cart.js: cart not found');
    return;
  }

  cart.displayCartDetails = function(e) {
    let t = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP' });
    this.cartContainer.innerHTML = '';

    let s = e.items_subtotal_price / 100;
    document.querySelector('.cart--subtotal').textContent = t.format(s);

    e.items.forEach((item, index) => {
      if ('Extras' === item.product_type) return;

      const el = document.createElement('li');
      el.classList.add('cart-main--item');
      el.dataset.position = index;

      if ('Accessories' === item.product_type) {
        el.innerHTML = `
          <div class="cart-main--item-top">
            <span class="cart-main--item-image">
              <img src="${item.image}" alt="${item.product_title}">
            </span>
            <div class="cart-main--item-titles">
              <span class="cart-main--item-title">${item.product_title}</span>
            </div>
          </div>
          <span class="cart-main--item-bottom">
            <span class="cart-main--item-action">
              <span class="cart-main--item-quantity">
                <button class="decrease-qty" data-line-item="${item.id}" data-position="${index}">-</button>
                <span class="line-item--quantity">${item.quantity}</span>
                <button class="increase-qty" data-line-item="${item.id}" data-position="${index}">+</button>
              </span>
              <span class="cart-main--item-price" data-price="${item.price}">${t.format(item.price / 100 * item.quantity)}</span>
              <span class="cart-main--item-delete" data-line-item="${item.id}" data-position="${index}">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1z" fill="#1b1e21"/><path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="#1b1e21"/></svg>
              </span>
            </span>
          </span>
        `;

} else if (item.product_type !== 'Cabinet Door') {
        // Standard range — simple variant layout
        el.innerHTML = `
          <div class="cart-main--item-top">
            <span class="cart-main--item-image">
              <img src="${item.image}" alt="${item.product_title}">
            </span>
            <div class="cart-main--item-titles">
<span class="cart-main--item-title">${item.product_title} - H ${item.variant_title.split(' / ')[0]}mm x W ${item.variant_title.split(' / ')[1]}mm</span>
            </div>
          </div>
          <span class="cart-main--item-bottom">
            <span class="cart-main--item-action">
              <span class="cart-main--item-quantity">
                <button class="decrease-qty" data-line-item="${item.id}" data-position="${index}">-</button>
                <span class="line-item--quantity">${item.quantity}</span>
                <button class="increase-qty" data-line-item="${item.id}" data-position="${index}">+</button>
              </span>
              <span class="cart-main--item-price" data-price="${item.price}">${t.format(item.price / 100 * item.quantity)}</span>
              <span class="cart-main--item-delete" data-line-item="${item.id}" data-position="${index}">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1z" fill="#1b1e21"/><path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="#1b1e21"/></svg>
              </span>
            </span>
          </span>
        `;

      } else {
        // Builder item — full layout with dimensions and add-ons
        let dims = item.properties.dimensions.split(',');
        let heightPart = dims[0].trim();
        let widthPart = dims[1].trim();
        let r = parseInt(heightPart.split(':')[1].trim(), 10);
        let c = parseInt(widthPart.split(':')[1].trim(), 10);
        let l = r > 1000 ? 1500 : 1000;
        let d = 500;

        el.innerHTML = `
          <div class="cart-main--item-top">
            <span class="cart-main--item-image">
              <img src="${item.image}" alt="${item.product_title}">
            </span>
            <div class="cart-main--item-titles">
              <span class="cart-main--item-title">${item.product_title} - H ${r}mm x W ${c}mm</span>
            </div>
          </div>

          <div class="cart-main--item-mid">
            <div class="cart-main--item-info">
              <span class="cart-main--item-info-title">Style:</span>
              <span class="cart-main--item-info-text">${item.product_title}</span>
            </div>
            <div class="cart-main--item-info">
              <span class="cart-main--item-info-title">Primed:</span>
              <span class="cart-main--item-info-text">${item.properties.primed}</span>
            </div>
            <div class="cart-main--item-info">
              <span class="cart-main--item-info-title">Size:</span>
              <span class="cart-main--item-info-text">H ${r}mm x W ${c}mm</span>
            </div>
            <div class="cart-main--item-info">
              <span class="cart-main--item-info-title">Hinge Holes:</span>
              <span class="cart-main--item-info-text">${item.properties.hingeHoles}</span>
            </div>
            ${'Yes' === item.properties.hingeCustom ? `
            <div class="cart-main--item-info">
              <span class="cart-main--item-info-title">Hinge Positions:</span>
              <span class="cart-main--item-info-text">${item.properties.hingeCustomPositions}</span>
            </div>` : ''}
            ${'Yes' === item.properties.hingeHoles ? `
            <div class="cart-main--item-info">
              <span class="cart-main--item-info-title">Hinge Side:</span>
              <span class="cart-main--item-info-text">${item.properties.hingeSide}</span>
            </div>` : ''}
            ${'No' === item.properties.hingeHoles ? `
            <div class="cart-main--item-info">
              <span class="cart-main--item-info-title">Hinge Butt:</span>
              <span class="cart-main--item-info-text">${item.properties.hingeButt}</span>
            </div>` : ''}
            ${'Yes' === item.properties.hingeButt ? `
            <div class="cart-main--item-info">
              <span class="cart-main--item-info-title">Butt Hinge Side:</span>
              <span class="cart-main--item-info-text">${item.properties.hingeButtSide}</span>
            </div>` : ''}
            <div class="cart-main--item-info">
              <span class="cart-main--item-info-title">Hinges:</span>
              <span class="cart-main--item-info-text">${item.properties.hinges}</span>
            </div>
            ${'Yes' === item.properties.hinges ? `
            <div class="cart-main--item-info">
              <span class="cart-main--item-info-title">Hinge Degree:</span>
              <span class="cart-main--item-info-text">${item.properties.hingeDegree}</span>
            </div>
            <div class="cart-main--item-info">
              <span class="cart-main--item-info-title">Hinge Type:</span>
              <span class="cart-main--item-info-text">${item.properties.hingeOption}</span>
            </div>` : ''}
            ${item.properties.midrail && r > 1599 ? `
            <div class="cart-main--item-info">
              <span class="cart-main--item-info-title">Midrail Type:</span>
              <span class="cart-main--item-info-text">${item.properties.midrail}</span>
            </div>` : ''}
            ${item.properties.midrailHeight && r > 1599 ? `
            <div class="cart-main--item-info">
              <span class="cart-main--item-info-title">Midrail Measurements:</span>
              <span class="cart-main--item-info-text">${item.properties.midrailHeight}</span>
            </div>` : ''}
          </div>

          <span class="cart-main--item-bottom">
            <span class="cart-main--item-action">
              <span class="cart-main--item-quantity">
                <button class="decrease-qty" data-line-item="${item.id}" data-position="${index}">-</button>
                <span class="line-item--quantity">${item.quantity}</span>
                <button class="increase-qty" data-line-item="${item.id}" data-position="${index}">+</button>
              </span>
              <span class="cart-main--item-price" data-price="${item.price}">${t.format(item.price / 100 * item.quantity)}</span>
              <span class="cart-main--item-delete" data-line-item="${item.id}" data-position="${index}">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1z" fill="#1b1e21"/><path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="#1b1e21"/></svg>
              </span>
            </span>
          </span>

          ${'Yes' === item.properties.hinges && 'Yes' === item.properties.hingeHoles ? `
          <div class="build-card--add-on">
            <div class="add-on--image-title">
              <div class="add-on--image">
                <img src="https://cdn.shopify.com/s/files/1/0808/9511/5585/files/jmf-hinges.jpg?v=1710112666" alt="">
              </div>
              <span class="title-xs">${item.properties.hingeDegree} ${item.properties.hingeOption}</span>
            </div>
            <div class="add-on--qty-money">
              <span class="qty title-xs" data-hinge-multiplier="${r >= 2401 ? 5 : r >= 1901 ? 4 : r >= 901 && r <= 1900 ? 3 : 2}">x${item.quantity * (r >= 2401 ? 5 : r >= 1901 ? 4 : r >= 901 && r <= 1900 ? 3 : 2)}</span>
              <span class="price title-xs" data-price="500">${t.format(500 * item.quantity / 100 * (r >= 2401 ? 5 : r >= 1901 ? 4 : r >= 901 && r <= 1900 ? 3 : 2))}</span>
            </div>
          </div>` : 'Yes' === item.properties.hingeButt && 'No' === item.properties.hingeHoles ? `
          <div class="build-card--add-on">
            <div class="add-on--image-title">
              <div class="add-on--image">
                <img src="https://cdn.shopify.com/s/files/1/0808/9511/5585/files/Plain_Shaker_Corner.jpg?v=1708293519" alt="Timber Inserts">
              </div>
              <span class="title-xs">Timber Inserts</span>
            </div>
            <div class="add-on--qty-money">
              <span class="qty title-xs">x${item.quantity}</span>
              <span class="price title-xs" data-price="${l}">${t.format(l * item.quantity / 100)}</span>
            </div>
          </div>` : ''}

          ${'Yes' === item.properties.hingeCustom ? `
          <div class="build-card--add-on">
            <div class="add-on--image-title">
              <div class="add-on--image">
                <img src="https://cdn.shopify.com/s/files/1/0808/9511/5585/files/HingeHoleDimension.jpg?v=1720436010" alt="Custom Hinge Position">
              </div>
              <span class="title-xs">Custom Hinge Positions</span>
            </div>
            <div class="add-on--qty-money">
              <span class="qty title-xs">x${item.quantity}</span>
              <span class="price title-xs" data-price="${d}">${t.format(d * item.quantity / 100)}</span>
            </div>
          </div>` : ''}
        `;
      }

      this.cartContainer.appendChild(el);
    });
  };

  console.log('standard-range-cart.js: patched successfully');
});
